export const FEEDBACK_MESSAGES = {
    nonFeasible: {
        message: 'Too many overdues. 🤯 Clean your drawer!',
    },
    feasibles: [{
        range: [0, 0.45],
        message: 'Risky Deadline. Enjoy energy drinks? ☕',
    }, {
        range: [0.45, 0.55],
        message: 'Not sure about this deadline. 😕 It\'s a tossup.',
    }, {
        range: [0.55, 0.80],
        message: 'Bold deadline. 💪 Fortune favores the bold.',
    }, {
        range: [0.80, 1],
        message: 'Deadline on easy mode. Go for it! ️⛱️',
    }],
};

export const TOAST_ID = 'deadline-estimate-feedback';
